module.exports = {
    message: {
        homeNavi: '首页',
        aboutNavi: '关于',
        testNavi: '测试',
        hello: '你好，世界',
        welcome: '这是一个简单的使用Vuejs和TypeScript的项目。现将其当作首页。',
        welcomeParagraphs: '这是BanG Dream! moe网站的首页。之前一直没有启用，显示的是Nginx安装成功后的欢迎页面。按近期网站的发展规划，首页将添加一些功能，此页面代表网站正在施工中，敬请期待。',
    }
}